<section class="bg-white intro">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 px-0 termekek">
        <section class="bg-white text-primary mt-5 mb-4 py-4">
          <div class="container pt-5">
            <div class="row pt-4">
              <div class="col-12 col-lg-10">
                <h1 class="bold">ENGEDÉLYEK</h1>
              </div>
            </div>
          </div>
        </section>
        <section class="bg-white mb-4 py-4 article-section">
          <div class="container">
            <div class="row justify-content-center">
              <ul>                
                <li><a class="download" href="{{weboldalDokumentumok}}e-ii-273-2008.pdf" target="_blank" rel="noopener" aria-label="PSZÁF alapítási engedély száma: E-II-273/2008 (PDF - új lapon nyílik meg)" title="Töltse le a PSZÁF alapítási engedély száma: E-II-273/2008 dokumentumot PDF formátumban.">PSZÁF alapítási engedély száma: E-II-273/2008</a></li>
                <li><a class="download" href="{{weboldalDokumentumok}}e-ii-396-2008.pdf" target="_blank" rel="noopener" aria-label="PSZÁF tevékenységi engedély száma: E-II-396/2008 (PDF - új lapon nyílik meg)" title="Töltse le a PSZÁF tevékenységi engedély száma: E-II-396/2008 dokumentumot PDF formátumban.">PSZÁF tevékenységi engedély száma: E-II-396/2008</a></li>
                <li><a class="download" href="{{weboldalDokumentumok}}en_ii_35_2011.pdf" target="_blank" rel="noopener" aria-label="PSZÁF tevékenységi engedély száma: EN-II-35/2011 (PDF - új lapon nyílik meg)" title="Töltse le a PSZÁF tevékenységi engedély száma: EN-II-35/2011 dokumentumot PDF formátumban.">PSZÁF tevékenységi engedély száma: EN-II-35/2011</a></li>
                <li><a class="download" href="{{weboldalDokumentumok}}en_ii_125_2011.pdf" target="_blank" rel="noopener" aria-label="PSZÁF tevékenységi engedély száma: EN-II-125/2011 (PDF - új lapon nyílik meg)" title="Töltse le a PSZÁF tevékenységi engedély száma: EN-II-125/2011 dokumentumot PDF formátumban.">PSZÁF tevékenységi engedély száma: EN-II-125/2011</a></li>
                <li><a class="download" href="{{weboldalDokumentumok}}H-EN-II-86_2016.pdf" target="_blank" rel="noopener" aria-label="H-EN-II-86/2016. számú határozat (PDF - új lapon nyílik meg)" title="Töltse le a H-EN-II-86/2016. számú határozat dokumentumot PDF formátumban.">H-EN-II-86/2016. számú határozat</a></li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</section>
